import { FC } from "react";
import ReactPlayer from "react-player";

interface IPlayer {
  contentUrl: string;
}

const VimeoPlayer: FC<IPlayer> = ({ contentUrl }) => {
  return (
    <ReactPlayer
    url={contentUrl}
      controls={true}
      width="100%"
      height="100%"
      style={{
        display: "block",
        marginRight: "auto",
      }}
    />
  );
};

export default VimeoPlayer;
